import React, { useState } from 'react';
import { Button, Box, Typography } from '@mui/material';
import {AddCircleRounded as AddCircleRoundedIcon } from '@mui/icons-material';
import { RemoveCircleRounded as RemoveCircleRoundedIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import { LOCALIZATION } from "../../utils/localization";


const ReadMoreReadLess = ({ text, maxLength = 100 }) => {
  const { t } = useTranslation();
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleReadMoreLess = () => {
    setIsExpanded(!isExpanded);
  };

  const renderText = () => {
    if (isExpanded) {
      return text;
    }
    if (text.length <= maxLength) {
      return text;
    }
    return text.substring(0, maxLength) + '...';
  };

  return (
    <Box>
      <Typography className="textInfo">{renderText()}</Typography>
      {text.length > maxLength && (
        <Box sx={{ display: "flex", alignItems: "center", paddingBottom:"15px" }}>
          <Button className="showMoreLessBtn" onClick={toggleReadMoreLess}>
            {/* {isExpanded ? t(LOCALIZATION.Show_Less) : t(LOCALIZATION.Show_More)} */}
            {isExpanded ? t(LOCALIZATION.Show_Less) : t(LOCALIZATION.Show_More)}
          </Button>
          <Button className="moreLessIconBtn" onClick={toggleReadMoreLess}>
            {isExpanded ? <RemoveCircleRoundedIcon /> : <AddCircleRoundedIcon />}
          </Button>
        </Box>
      )}
    </Box>
  );
};

export default ReadMoreReadLess;